var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4917 1.66675H6.50833C3.475 1.66675 1.66666 3.47508 1.66666 6.50841V13.4834C1.66666 16.5251 3.475 18.3334 6.50833 18.3334H13.4833C16.5167 18.3334 18.325 16.5251 18.325 13.4917V6.50841C18.3333 3.47508 16.525 1.66675 13.4917 1.66675Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.08325H5C4.65833 7.08325 4.375 6.79992 4.375 6.45825C4.375 6.11659 4.65833 5.83325 5 5.83325H15C15.3417 5.83325 15.625 6.11659 15.625 6.45825C15.625 6.79992 15.3417 7.08325 15 7.08325Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.625H6.66666C6.325 10.625 6.04166 10.3417 6.04166 10C6.04166 9.65833 6.325 9.375 6.66666 9.375H13.3333C13.675 9.375 13.9583 9.65833 13.9583 10C13.9583 10.3417 13.675 10.625 13.3333 10.625Z",
    fill: "#838B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1083 14.1667H8.88326C8.5416 14.1667 8.25826 13.8834 8.25826 13.5417C8.25826 13.2001 8.5416 12.9167 8.88326 12.9167H11.1083C11.4499 12.9167 11.7333 13.2001 11.7333 13.5417C11.7333 13.8834 11.4583 14.1667 11.1083 14.1667Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.266afad51bbf6b21fd1f5619e7914e49.svg";
export { ForwardRef as ReactComponent };